'use client';

import dynamic from 'next/dynamic';

// three.js is ~360 KiB: imported from the server block it became an entry script on every page
const LazyClient = dynamic(() => import('./Client'));

export default LazyClient;
